import base from "./base";
import client from "./client";
import clientRecord from "./clientRecord";
import counsel from "./counsel";
import counselForTemporary from "./counselForTemporary";
import group from "./group";
import item from "./item";
import activity from "./activity";
import complain from "./complain";
import desk from "./desk";
import accessRequest from "./accessRequest";
import statistics from "./statistics";
import admin from "./admin";

export default {
    base,
    admin,
    client,
    clientRecord,
    counsel,
    counselForTemporary,
    group,
    item,
    activity,
    complain,
    desk,
    accessRequest,
    statistics,
};
